import styled from "styled-components";
import { PickList } from "primereact/picklist";

export const StyledPickListWrapper = styled(PickList)`
  button {
    padding: 10px 5px !important;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  height: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  justify-content: end;
`;
